import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default class UpdateClient extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "updateClient";
    }

    public receive(payload: CometOperatorApplication.UpdateClientCometMessageOpenApiModel): void {
        if (payload.client && ClientUserdataStore.hasClientByUsername(payload.client.username)) {
            ClientUserdataStore.set(payload.client);
        }
    }

}